import { vhmEmptyMsgClasses, vhmVersionItemClasses } from "./versionHistoryClasses";

const VersionList = ({ versions, fileKey, lifecareClientId, onDownload, formatVersionLabel, isLoading }) => {
  if (isLoading) return <div className={vhmEmptyMsgClasses}>Loading version history</div>;
  if (!versions.length) return <div className={vhmEmptyMsgClasses}>No versions available</div>;
  return versions.map((v) => (
    <div
      key={v.versionId}
      className={vhmVersionItemClasses}
      onClick={() => onDownload({ fileKey, versionNumber: v.versionNumber, lifecareClientId })}
    >
      {formatVersionLabel({ versionNumber: v.versionNumber, lastModified: v.lastModified, requestedBy: v.requestedBy })}
    </div>
  ));
};

export default VersionList;
